import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import {
  selectIsRecommendedPackagePaymentStatusCheckInProgress,
  selectRecommendedPackagePaymentStatus,
} from '../../../../../../../selectors/depositAccount';
import { useCheckPaymentQueue } from '../../../../../../../hooks';

export const useRecommendedPackagesPaymentStatus = () => {
  const { runCheckPaymentQueue } = useCheckPaymentQueue();

  const isRender = useSelector(selectIsRecommendedPackagePaymentStatusCheckInProgress);
  const status = useSelector(selectRecommendedPackagePaymentStatus);

  const handleRetryClick = useCallback(() => {
    runCheckPaymentQueue();
  }, [runCheckPaymentQueue]);

  return { isRender, status, handleRetryClick };
};
